module.exports = __webpack_public_path__ + "img/house.46b50d57.png";